import { Component, OnInit, OnDestroy, LOCALE_ID, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { of, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { CompanyService, NotificationFacade, CompanyFacade } from '@ridango/components';
import { AuthService, LogService, NotificationService, Notification } from '@ridango/core';
import { Location } from '@angular/common';
import { BasePageComponent } from '../../shared/components/base-page/base-page.component';
import { HelperService } from '../../shared/services/helper.service';
import { CompanyNgrxService } from '@ridango/components/lib/company-ngrx/company.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    templateUrl: './department-profile-add.component.html'
})
export class DepartmentProfileAddComponent extends BasePageComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();

    departmentForm: FormGroup;
    isNewDepartment = false;
    companyId: string;

    constructor(
        @Inject(LOCALE_ID) public locale: string,
        private companyService: CompanyService,
        private auth: AuthService,
        private ls: LogService,
        private notifications: NotificationService,
        private notification: NotificationFacade,
        private hs: HelperService,
        private location: Location,
        private companyFacade: CompanyFacade,
        private route: ActivatedRoute,
        private companyNgrxService: CompanyNgrxService,
        private translate: TranslateService
    ) {
        super(hs);

        this.departmentForm = new FormGroup({
            name: new FormControl('', [Validators.required]),
            contactName: new FormControl('', [Validators.required]),
            contactEmail: new FormControl('', [Validators.required, Validators.email]),
            contactPhone: new FormControl('', [Validators.required])
        });
    }

    ngOnInit() {
        this.companyId = this.auth.getLoggedInUserCompanyId();

        this.route.url
            .pipe(
                switchMap((urlSegments) => {
                    if (urlSegments.length > 0 && urlSegments[0].path.includes('add-department')) {
                        this.isNewDepartment = true;
                        return of(null);
                    } else {
                        return this.companyNgrxService.fetchCompany(this.companyId);
                    }
                }),
                takeUntil(this.componentDestroyed$)
            )
            .subscribe((company) => {
                if (company) {
                    this.departmentForm.patchValue(company);
                }
            });
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
        super.ngOnDestroy();
    }

    cancelAdd() {
        this.location.back();
    }

    submitDepartment() {
        if (this.departmentForm.valid) {
            if (this.isNewDepartment) {
                this.companyService.saveDepartmentProfile(this.departmentForm.value, this.companyId).subscribe(
                    (d) => {
                        this.companyService.setSelectedCompany(d);
                        this.notification.success(this.translate.instant('LOCAL_NEW_DEPARTMENT_PROFILE_SAVED_SUCCESS'));
                    },
                    (e) => {
                        this.ls.log(this, 'submitProfile', e);
                        this.notifications.add(
                            new Notification(
                                this.notifications.notificationTypes.ERROR,
                                this.translate.instant(e.error)
                            )
                        );
                    }
                );
            } else {
                this.companyNgrxService.updateDepartmentProfile(this.departmentForm.value, this.companyId).subscribe(
                    (d) => {
                        this.companyService.setSelectedCompany(d);
                        this.notification.success(this.translate.instant('LOCAL_DEPARTMENT_PROFILE_UPDATED_SUCCESS'));
                    },
                    (e) => {
                        this.ls.log(this, 'submitProfile', e);
                        this.notifications.add(
                            new Notification(
                                this.notifications.notificationTypes.ERROR,
                                this.translate.instant(e.error)
                            )
                        );
                    }
                );
            }
        } else {
            this.notifications.add(
                new Notification(this.notifications.notificationTypes.ERROR, 'DEPARTMENT_FORM_ALL_FIELDS_REQUIRED')
            );
        }
    }
}
